import { render, staticRenderFns } from "./CreateFactoryAddress.vue?vue&type=template&id=6b68907b&scoped=true"
import script from "./CreateFactoryAddress.vue?vue&type=script&lang=ts"
export * from "./CreateFactoryAddress.vue?vue&type=script&lang=ts"
import style0 from "./CreateFactoryAddress.vue?vue&type=style&index=0&id=6b68907b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b68907b",
  null
  
)

export default component.exports